import { create } from 'zustand';
const useDataStore = create((set) => ({
    components: {},
    data: {},
    firstFetchIsReady: false,
    setData: (path, fetchedData, isProductPage) => {
        set((state) => ({
            data: { ...state.data, [path]: { ...fetchedData, isProductPage } },
        }));
    },
    setFirstFetch: (firstFetchIsReady) => {
        set(() => ({ firstFetchIsReady }));
    },
}));
export default useDataStore;
